// Reference data for the Security Access Simulator: security levels (sub-function pairs)
// and the Negative Response Codes this tool can produce. Kept separate from the session
// engine so the reference table used by the UI and the NRC values the engine actually
// throws can never drift apart.

// Real UDS SecurityAccess sub-functions are always an odd (request seed) / even (send key)
// pair for the same level: level N -> requestSeed = 2N-1, sendKey = 2N.
export const SECURITY_LEVELS = [
  { id: 1, label: 'Level 1', requestSubFn: 0x01, sendKeySubFn: 0x02 },
  { id: 3, label: 'Level 3', requestSubFn: 0x03, sendKeySubFn: 0x04 },
  { id: 5, label: 'Level 5', requestSubFn: 0x05, sendKeySubFn: 0x06 },
];

export const SECURITY_LEVEL_BY_ID = Object.fromEntries(SECURITY_LEVELS.map((l) => [l.id, l]));

export const NRC_TABLE = {
  0x24: { name: 'requestSequenceError', meaning: 'A key was sent with no outstanding seed request for this level.' },
  0x35: { name: 'invalidKey', meaning: 'The key sent does not match the key computed from the last issued seed.' },
  0x36: { name: 'exceedNumberOfAttempts', meaning: 'Too many invalid keys in a row — further attempts are locked out for a delay period.' },
  0x37: { name: 'requiredTimeDelayNotExpired', meaning: 'A Security Access attempt was made while the lockout delay timer is still running.' },
};

export const DEFAULT_MAX_ATTEMPTS = 3;
export const DEFAULT_LOCKOUT_MS = 30000;
